import React, { createContext, useState } from 'react';
import { useRouter } from 'next/router';
const AppStateContext = createContext();

export function AppProvider({ children }) {
  const [language, setLanguage] = useState('en');
  const router = useRouter();
  const changeLanguage = (lang) => {
    const { pathname, asPath, query } = router;
    router.push({ pathname, query }, asPath, {
      locale: lang === 'en-US' ? 'en' : 'sv',
    });
    setLanguage(lang === 'en-US' ? 'en' : 'sv');
  };

  let sharedState = {
    language,
    changeLanguage,
  };

  return <AppStateContext.Provider value={sharedState}>{children}</AppStateContext.Provider>;
}

export function useAppState() {
  const state = React.useContext(AppStateContext);

  if (state === undefined) {
    throw new Error('useAppState must be used within a AppProvider');
  }

  return state;
}
